import React from 'react';

import type { LogoProps } from '@atlaskit/logo';

import { useCommonContent } from '../../../use-content/index.tsx';

export const Header = (props: LogoProps) => {
	const { Logo } = useCommonContent();
	return <Logo size="small" appearance="brand" shouldUseNewLogoDesign {...props} />;
};
